/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react'
import { pluck, uniq } from 'underscore'
import Tree from './Tree'
import type { PackageArtifactSelectorProps } from './types'

const PackageArtifactSelector: React.FC<PackageArtifactSelectorProps> = ({
  options,
  preselectedData,
  updateOptionsData,
  setManuallySelectedArtifactIds,
  filterSelectedArtifactIds
}) => {
  const [selectedItems, setSelectedItems] = useState<number[]>([])

  useEffect(() => {
    setSelectedItems(preselectedData?.length ? uniq([...pluck(preselectedData, 'id')]) : [])
  }, [preselectedData])

  const handleSelectionChange = (id: number | string, isChecked: boolean, dataIndex: number) => {
    updateOptionsData(id, isChecked, dataIndex)
    if (Number.isInteger(id)) {
      setManuallySelectedArtifactIds((prev) => {
        const newSet = new Set(prev)
        if (isChecked) {
          newSet.add(id as number)
        } else {
          newSet.delete(id as number)
        }
        return newSet
      })
    } else {
      const sectionStr = (id as string).split('_')[1]
      const zone = options?.fileplanEntries?.[dataIndex]
      const section = sectionStr ? zone?.children?.filter((item) => item?.name === sectionStr) : zone?.children
      const selectedArtifactsArr = section?.reduce((acc: number[], item) => {
        const ids = pluck(item?.children || [], 'id').filter((id): id is number => id !== undefined)
        acc.push(...ids)
        return acc
      }, [])

      setManuallySelectedArtifactIds((prev) => {
        const newSet = new Set(prev)
        if (isChecked) {
          selectedArtifactsArr?.forEach((id) => (!filterSelectedArtifactIds.has(id) ? newSet.add(id) : null))
        } else {
          selectedArtifactsArr?.forEach((id) => newSet.delete(id))
        }
        return newSet
      })
    }
  }

  return (
    <div>
      {options?.fileplanEntries?.map((item, index) => (
        <Tree
          artifactData={item}
          onChange={(id, isChecked) => handleSelectionChange(id, isChecked, index)}
          selectedArticafts={selectedItems}
          key={index}
        />
      ))}
    </div>
  )
}

export default PackageArtifactSelector
